import {ProductParams} from './ProductParams'
import {ProductCustomAttribute} from './ProductCustomAttribute'
import {ProductResponse} from './ProductResponse'

/**
 * Product description. <br/>
 * We will present the data from this object on the website to end users.
 * The object describes the recommended product.
 * The data contained in the product is the data from the catalog transferred to the Quarticon system
 */
export class Product implements ProductParams{
    private readonly _id: string;
    private readonly _pageUrl: string;
    private readonly _imageUrl: string;
    private readonly _price: string;
    private readonly _priceOld: string;
    private readonly _title: string;
    private readonly _custom: ProductCustomAttribute[];

    /** @ignore */
    constructor(params: ProductParams) {
        this._id = params.id
        this._pageUrl = params.pageUrl
        this._imageUrl = params.imageUrl
        this._price = params.price
        this._priceOld = params.priceOld
        this._title = params.title
        this._custom = params.custom
    }

    /** @ignore */
    public static createFromResponse = (requestProduct: ProductResponse): Product => {
        const custom: ProductCustomAttribute[] = []
        if (requestProduct.custom_1) {
            custom.push({name: '1', value: requestProduct.custom_1})
        }
        if (requestProduct.custom_2) {
            custom.push({name: '2', value: requestProduct.custom_2})
        }
        if (requestProduct.custom_3) {
            custom.push({name: '3', value: requestProduct.custom_3})
        }
        if (requestProduct.custom_4) {
            custom.push({name: '4', value: requestProduct.custom_4})
        }


        const params: ProductParams = {
            id: requestProduct.id,
            pageUrl: requestProduct.link,
            imageUrl: requestProduct.image ?? '',
            price: requestProduct.price ?? '',
            priceOld: requestProduct.old_price ?? '',
            custom: custom,
            title: requestProduct.title ?? ''
        }

        return new Product(params)
    }

    /** Product identifier */
    get id(): string {
        return this._id
    }

    /** Product page url */
    get pageUrl(): string {
        return this._pageUrl
    }

    /** Product image link */
    get imageUrl(): string {
        return this._imageUrl
    }

    /** Product price */
    get price(): string {
        return this._price
    }

    /** Product old price */
    get priceOld(): string {
        return this._priceOld
    }

    /** Product title */
    //ts-ignore
    get title(): string {
        return this._title
    }

    /** Product additional custom data */
    get custom(): Array<ProductCustomAttribute> {
        return this._custom
    }
}
